<template>
  <div>
    <el-dialog
      class="mode"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      custom-class="layout-dialog"
      title="建物選択"
      top="5vh"
      width="1024px"
      :visible.sync="dialogVisible"
      :show-close="false"
      append-to-body
      @opened="opened"
      @close="close"
    >
      <vab-query-form-mode
        :model="queryForm"
        :rules="rules"
        class="dpform noborder"
        :enable-query-save="false"
        size="mini"
        label-position="left"
        label-width="120px"
        @search="onSearch"
      >
        <el-row :gutter="30">
          <el-col :span="8">
            <vab-input
              label="建物CD"
              validate="max:6"
              maxlength="6"
              prop="blgscd"
            />
          </el-col>
          <el-col :span="8">
            <vab-input label="所属部課CD" prop="pstsctcd" maxlength="6" />
          </el-col>
          <el-col :span="8">
            <vab-input label="得意先CD" prop="bcncd" maxlength="9" />
          </el-col>
          <el-col :span="12">
            <vab-input
              label-width="140px"
              label="建物名称カナ１(ｶﾅ)"
              maxlength="68"
              prop="blgsnmkn1"
              validate="halfKana"
            />
          </el-col>
          <el-col :span="12">
            <vab-input
              label-width="140px"
              label="建物名称カナ２(ｶﾅ)"
              maxlength="68"
              prop="blgsnmkn2"
              validate="halfKana"
            />
          </el-col>
          <el-col :span="12">
            <vab-input
              label-width="180px"
              label="所属部課名(半角ｶﾅ)"
              maxlength="35"
              prop="orgknnm"
              validate="halfKana"
            />
          </el-col>
          <el-col :span="12">
            <vab-input
              label-width="160px"
              label="得意先名(半角ｶﾅ)"
              prop="bcnknnm"
              maxlength="60"
              validate="halfKana"
            />
          </el-col>
        </el-row>
      </vab-query-form-mode>
      <el-row class="m20">
        <el-col :span="24">
          <vab-table
            ref="table"
            api-url="/api/mbuildgp/query"
            :columns="columns"
            :custom-config="false"
            :multi-select="multiSelect"
            height="300"
            :query-params.sync="queryForm"
            :row-key="getRowKey"
            :enable-init="false"
            @selection-change="setSelectRows"
          />
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer flex_end">
        <div class="flex_start flex_center_align">
          <el-button class="cancel" @click="close">キャンセル</el-button>
          <!-- <div class="cancel" @click="close">キャンセル</div> -->
          <el-button type="primary" @click="save()">確定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import mixDialog from '@/utils/mixDialog'
  export default {
    name: 'BuildDialog',
    mixins: [mixDialog],
    data() {
      return {
        queryForm: {
          blgscd: null,
          blgsnmkn1: null,
          blgsnmkn2: null,
          pstsctcd: null,
          voidf: null,
          bcncd: null,
          bcnknnm: null,
        },
        columns: [
          {
            label: '建物CD',
            'min-width': 80,
            prop: 'blgscd',
          },
          {
            label: '建物名(半角ｶﾅ)１',
            'min-width': 120,
            prop: 'blgsnmkn1',
          },
          {
            label: '建物名(半角ｶﾅ)２',
            'min-width': 120,
            prop: 'blgsnmkn2',
          },
          {
            label: '建物名称',
            'min-width': 120,
            prop: 'blgsnmkj',
          },
          {
            label: '所属部課CD',
            'min-width': 100,
            prop: 'pstsctcd',
          },
          {
            label: '所属部課名',
            'min-width': 120,
            prop: 'orgkj',
          },
          {
            label: '得意先CD',
            'min-width': 100,
            prop: 'bcncd',
          },
          {
            label: '得意先名',
            'min-width': 120,
            prop: 'bcnfrkj',
          },
        ],
      }
    },
    methods: {
      getRowKey(row) {
        return row.blgscd + '-' + row.bldgcd
      },
      handleClick() {},
    },
  }
</script>
